import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { CenteredLoader } from 'components';
import { checkPasswordResetToken, forgotPassword } from 'actions/app.actions';
import {
  passwordResetTokenSelector,
  loginLoadingSelector,
} from 'reducers/app.reducer';
import useQuery from 'core/utils/use-query.hook';
import InvalidResetPasswordLink from './InvalidResetPasswordLink';

interface IPasswordTokenHandler {
  children: (token?: string) => JSX.Element;
  isTokenRequired?: boolean;
}

const URL_AUTH_TOKEN = 'token';
export default function PasswordTokenHandler({
  isTokenRequired,
  children,
}: IPasswordTokenHandler) {
  const dispatch = useDispatch();
  const isLoginLoading = useSelector(loginLoadingSelector);
  const { isLoading, isValid, email } = useSelector(passwordResetTokenSelector);

  const { [URL_AUTH_TOKEN]: urlToken } = useQuery();

  useEffect(() => {
    if (urlToken) {
      dispatch(checkPasswordResetToken.request(urlToken));
    }
  }, [urlToken, dispatch]);

  if ((!isTokenRequired && !urlToken) || isValid) {
    return children(urlToken);
  }

  if (isLoading) {
    return <CenteredLoader />;
  }

  return (
    <InvalidResetPasswordLink
      isLoading={isLoginLoading}
      hasError={!email}
      onEmailSend={() => dispatch(forgotPassword.request(email!))}
    />
  );
}
